export const HOME_PAGE_LOADED = "HOME_PAGE_LOADED";
export const FETCH_ARTICLES_ALL = "FETCH_ARTICLES_ALL";
// APP
export const APP_LOAD = "APP_LOAD";

// FEED
export const FEED_REQUEST = "FEED_REQUEST";
export const FEED_SUCCESS = "FEED_SUCCESS";
export const FEED_FAILURE = "FEED_FAILURE";

// PUBLISHED
export const PUBLISHED_ARTICLES_REQUEST = "PUBLISHED_ARTICLES_REQUEST";
export const PUBLISHED_ARTICLES_SUCCESS = "PUBLISHED_ARTICLES_SUCCESS";
export const PUBLISHED_ARTICLES_FAILURE = "PUBLISHED_ARTICLES_FAILURE";

// FAVORITED
export const FAVORITED_ARTICLES_REQUEST = "FAVORITED_ARTICLES_REQUEST";
export const FAVORITED_ARTICLES_SUCCESS = "FAVORITED_ARTICLES_SUCCESS";
export const FAVORITED_ARTICLES_FAILURE = "FAVORITED_ARTICLES_FAILURE";

// TAGGED
export const TAGGED_ARTICLES_REQUEST = "TAGGED_ARTICLES_REQUEST";
export const TAGGED_ARTICLES_SUCCESS = "TAGGED_ARTICLES_SUCCESS";
export const TAGGED_ARTICLES_FAILURE = "TAGGED_ARTICLES_FAILURE";

// ARTICLES
export const ARTICLES_REQUEST = "ARTICLES_REQUEST";
export const ARTICLES_SUCCESS = "ARTICLES_SUCCESS";
export const ARTICLES_FAILURE = "ARTICLES_FAILURE";

// ARTICLE
export const ARTICLE_REQUEST = "ARTICLE_REQUEST";
export const ARTICLE_SUCCESS = "ARTICLE_SUCCESS";
export const ARTICLE_FAILURE = "ARTICLE_FAILURE";

// ERROR
export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";

// AUTH
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// USER ACTIONS
export const SETTINGS_REQUEST = "SETTINGS_REQUEST";
export const SETTINGS_SUCCESS = "SETTINGS_SUCCESS";
export const SETTINGS_FAILURE = "SETTINGS_FAILURE";

// COMMENTS
export const COMMENTS_REQUEST = "COMMENTS_REQUEST";
export const COMMENTS_SUCCESS = "COMMENTS_SUCCESS";
export const COMMENTS_FAILURE = "COMMENTS_FAILURE";

// COMMENT
export const COMMENT_ADD_REQUEST = "COMMENT_ADD_REQUEST";
export const COMMENT_ADD_SUCCESS = "COMMENT_ADD_SUCCESS";
export const COMMENT_ADD_FAILURE = "COMMENT_ADD_FAILURE";

export const COMMENT_DELETE_REQUEST = "COMMENT_DELETE_REQUEST";
export const COMMENT_DELETE_SUCCESS = "COMMENT_DELETE_SUCCESS";
export const COMMENT_DELETE_FAILURE = "COMMENT_DELETE_FAILURE";

// PROFILE
export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAILURE = "PROFILE_FAILURE";

export const CREATE_ARTICLE_REQUEST = "CREATE_ARTICLE_REQUEST";
export const CREATE_ARTICLE_SUCCESS = "CREATE_ARTICLE_SUCCESS";
export const CREATE_ARTICLE_FAILURE = "CREATE_ARTICLE_FAILURE";

export const UPDATE_ARTICLE_REQUEST = "UPDATE_ARTICLE_REQUEST";
export const UPDATE_ARTICLE_SUCCESS = "UPDATE_ARTICLE_SUCCESS";
export const UPDATE_ARTICLE_FAILURE = "UPDATE_ARTICLE_FAILURE";

export const DELETE_ARTICLE_REQUEST = "DELETE_ARTICLE_REQEUST";
export const DELETE_ARTICLE_SUCCESS = "DELETE_ARTICLE_SUCCESS";
export const DELETE_ARTICLE_FAILURE = "DELETE_ARTICLE_FAILURE";

export const FOLLOW_REQUEST = "FOLLOW_REQUEST";
export const FOLLOW_SUCCESS = "FOLLOW_SUCCESS";
export const FOLLOW_FAILURE = "FOLLOW_FAILURE";

export const UNFOLLOW_REQUEST = "UNFOLLOW_REQUEST";
export const UNFOLLOW_SUCCESS = "UNFOLLOW_SUCCESS";
export const UNFOLLOW_FAILURE = "UNFOLLOW_FAILURE";

export const FAVORITE_REQUEST = "FAVORITE_REQUEST";
export const FAVORITE_SUCCESS = "FAVORITE_SUCCESS";
export const FAVORITE_FAILURE = "FAVORITE_FAILURE";

export const UNFAVORITE_REQUEST = "UNFAVORITE_REQUEST";
export const UNFAVORITE_SUCCESS = "UNFAVORITE_SUCCESS";
export const UNFAVORITE_FAILURE = "UNFAVORITE_FAILURE";

export const TAGS_REQUEST = "TAGS_REQUEST";
export const TAGS_SUCCESS = "TAGS_SUCCESS";
export const TAGS_FAILURE = "TAGS_FAILURE";

// PAGE
export const ARTICLE_PAGE_UNLOAD = "ARTICLE_PAGE_UNLOAD";
